<template>
    <div class="field has-addons pt-5">
        <p class="control is-expanded mb-0">
            <input
                v-if="text"
                :value="text"
                readonly
                class="input"
                type="text"
            />
        </p>
        <p class="control">
            <a
                :class="{
                    'has-tooltip-active': showCopiedTooltip,
                }"
                :data-tooltip="
                    $t(
                        showCopiedTooltip
                            ? 'tooltips.url_copied'
                            : 'tooltips.copy_url'
                    )
                "
                class="button is-disabled"
                @click="copyText"
            >
                <span class="icon is-small">
                    <i class="mdi mdi-18px mdi-content-copy"></i>
                </span>
            </a>
        </p>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: undefined,
        },
    },
    data() {
        return {
            showCopiedTooltip: false,
        };
    },
    methods: {
        copyText() {
            this.$copyText(this.text).then((e) => {
                this.showCopiedTooltip = true;
                setTimeout(() => {
                    this.showCopiedTooltip = false;
                }, 1500);
            });
        },
    },
};
</script>

<style></style>
